// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__6pnJN","footer":"ChangeClinic_footer__DHbZi"};